import gql from 'graphql-tag'

// POST /api/outbound-issue/list
const outboundIssuesGetQuery = gql`
  query outboundIssuesGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: Boolean) {
    outboundIssuesGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "OutboundIssuesListResult", method: "POST", path: "outbound-issue/list") {
      results
      paging
    }
  }
`

export default outboundIssuesGetQuery
